export const IS_SPANISH = "IS_SPANISH";
